import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        query {
          settings {
            name,
            value
          }
        }
      `
    })
  },
  getGlobalSetting(tag = 'in_status') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        query {
          settingsGlobal(
            tag: "${tag}"
          ) {
            id,
            tag,
            value
          }
        }
      `
    })
  },
  updateKeyValue(data) {
    return axios.post('', {
      query: `
        mutation {
          updateSettings (
            ${data.key}: ${typeof data.value === 'object' ? `[${data.value}]` : data.value }
          )
        }
      `
    })
  },
  update(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'

    return axios.post('', {
      query: `
        mutation {
          updateSettings (
            spam_interval_messages: ${data.spam_interval_messages}
            spam_interval_minutes: ${data.spam_interval_minutes}
            spam_interval_limit: ${data.spam_interval_limit}
            notifications_phone_number: "${data.notifications_phone_number}",
            send_campaign_to_all: ${data.send_campaign_to_all},
            resend_failed_dispatches: ${data.resend_failed_dispatches},
            spam_resend_failed_dispatches: ${data.spam_resend_failed_dispatches},
            block_customers_all_instances: ${data.block_customers_all_instances},
            redirect_idle_minutes: ${data.redirect_idle_minutes},
            request_transfer_minutes: ${data.request_transfer_minutes},
            always_send_passive_flow: ${data.always_send_passive_flow},
            alloy_sleep_passive_flow: ${data.alloy_sleep_passive_flow},
            enable_back_option_passive_flow: ${data.enable_back_option_passive_flow},
            priority_tickets_in_passive_flow: ${data.priority_tickets_in_passive_flow},
            priority_without_passive_flow: ${data.priority_without_passive_flow},
            priority_without_passive_flow_minutes: ${data.priority_without_passive_flow_minutes},
            reply_customer_chat_option_choose: ${data.reply_customer_chat_option_choose},
            send_message_LGPD_in_flow: ${data.send_message_LGPD_in_flow}
            disconnect_all_chats_at_midnight: ${data.disconnect_all_chats_at_midnight},
            disconnect_all_search_at_midnight: ${data.disconnect_all_search_at_midnight},
            finish_chat_tickets_by_inactivity: ${data.finish_chat_tickets_by_inactivity},
            finish_chat_tickets_by_inactivity_minutes: ${data.finish_chat_tickets_by_inactivity_minutes},
            finish_chat_tickets_by_inactivity_unit: ${data.finish_chat_tickets_by_inactivity_unit},
            finish_chat_tickets_by_inbox_inactivity: ${data.finish_chat_tickets_by_inbox_inactivity},
            finish_chat_tickets_by_inbox_inactivity_minutes: ${data.finish_chat_tickets_by_inbox_inactivity_minutes},
            finish_chat_tickets_by_inbox_inactivity_unit: ${data.finish_chat_tickets_by_inbox_inactivity_unit},
            send_inactivity_follow_up: ${data.send_inactivity_follow_up},
            inactivity_follow_up_minutes: ${data.inactivity_follow_up_minutes},
            inactivity_follow_up_unit: ${data.inactivity_follow_up_unit},
            is_mandatory_research: ${data.is_mandatory_research},
            send_report_every_day: ${data.send_report_every_day},
            send_order_status_notification: ${data.send_order_status_notification},
            email: """${data.email}""",
            show_username_on_chat: ${data.show_username_on_chat},
            unify_connections: ${data.unify_connections},
            relate_chat_tickets_to_next_user: ${data.relate_chat_tickets_to_next_user}
            older_inbox_chats_first_only: ${data.older_inbox_chats_first_only},
            older_inbox_chats_obligatorie_in_first: ${data.older_inbox_chats_obligatorie_in_first},
            limit_chat_tickets: ${data.limit_chat_tickets},
            limit_chat_tickets_activated: ${data.limit_chat_tickets_activated},
            medications_options_is_disabled: ${data.medications_options_is_disabled},
            enable_negative_stock: ${data.enable_negative_stock},
            always_send_new_passive_flow: ${data.always_send_new_passive_flow},
            send_triage_flow: ${data.send_triage_flow},
            send_sale_flow: ${data.send_sale_flow},
            allow_delivery_option_sale_flow: ${data.allow_delivery_option_sale_flow},
            expiration_password: ${data.expiration_password},
            date: "${data.date}",
            time: "${data.time}",
            selected: "${data.selected}",
          )
        }
      `
    })
  },
  updatePassiveBotSchedule(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'

    return axios.post('', {
      query: `
        mutation {
          updateSettings (
            passive_bot_schedule: "${data.passiveBotSchedule}",
            passive_bot_schedule_message: "${data.passiveBotScheduleMessage}",
            passive_bot_schedule_message_pause: "${data.passiveBotScheduleMessagePause}",
            use_department_schedule: ${data.useSchedulingInDepartament},
            use_scheduling: ${data.useScheduling},
          )
        }
      `
    })
  },
  fetchWppQrCode(instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'

    return axios.post('', {
      query: `
        mutation {
          changeWppQrCode (instance_id: ` + instanceId + `) {
            id,
            name,
            hub_host,
            browser_session,
            qr_code,
            reset_finished,
            activated
          }
        }
      `
    })
  },
  askQrcode2Fa(user) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          askQrcode2Fa () {
            id,
          }
        }
      `
    })
  }
}
